import { phpRecommendBadgeCaptions, phpRecommendBadgeConfig, phpRecommendBadgeIcons } from "../core/php-data-access";

export type RecommendBadgeKey = "new" | "recommend" | "rank";

export class RecommendBadgeIconsUtils {
    public static shouldShowRecommendBadgeRank(element: HTMLElement | null = null): boolean {
        const local = element?.dataset?.showRank;
        if (local === "0") return false;
        if (local === "1") return true;

        return phpRecommendBadgeConfig()?.showRankDefault !== false;
    }

    public static getRecommendBadgeCaption(key: RecommendBadgeKey, fallback: string): string {
        const captions = phpRecommendBadgeCaptions();
        const value = captions?.[key];
        return typeof value === "string" && value.trim() !== "" ? value : fallback;
    }

    public static getRecommendBadgeIconClass(key: RecommendBadgeKey, fallback: string): string {
        const icons = phpRecommendBadgeIcons();
        const value = icons?.[key];
        return typeof value === "string" && value.trim() !== "" ? value : fallback;
    }
}
